import SelectHoc from 'contexts/SelectHoc';
import { getOrderContext } from 'contexts/order';
import React from 'react';
import Req from 'utils/Request';
import { formatNumber } from 'utils/vanillaFunctions';

const buildLabel = (d) => {
    const valuePart =
        d.mode === 'percentage'
            ? `${parseFloat(d.value)}%`
            : `${formatNumber(parseFloat(d.value))}₮`;
    return `${d.name} (${valuePart})`;
};

const DiscountSelect = () => {
    const { address, discount, setDiscount } = React.useContext(getOrderContext);
    const [data, setData] = React.useState([]);

    const orderType = address?.haveDelivery ? 'delivery' : 'pickup';

    const fetchData = async () => {
        try {
            const result = await Req({
                url: '/menu2/discount/list',
                body: { orderType, isActive: true },
                hideSuccess: true,
                hideError: true,
            });
            const mapped = (result.data.data || []).map((d) => ({
                value: d.code,
                label: buildLabel(d),
                data: d,
            }));
            setData(mapped);
            // Clear a previously selected discount that no longer applies to this order type
            if (discount && !mapped.some((m) => m.value === discount.code)) {
                setDiscount(null);
            }
        } catch (e) {
            setData([]);
        }
    };

    React.useEffect(() => {
        if (address) fetchData();
    }, [orderType, address]);

    const value = discount
        ? { value: discount.code, label: buildLabel(discount) }
        : null;

    const forwardChange = (e) => {
        setDiscount(e?.data || null);
    };

    return (
        <SelectHoc
            value={value}
            onChange={forwardChange}
            options={data}
            placeholder="Хямдрал сонгох"
        />
    );
};

export default DiscountSelect;
